import * as style from './ModalForm.css';
import { ModalSidebar } from '../ModalSidebar';
import { Failed } from '../Failed';
import { clsx } from 'clsx';
import { EModalStatus, TModalStatus } from 'shared/types/modal';
import { TSteps } from 'shared/types/form';
import { Responsive, useDeviceType } from '@cian/ui-kit';

interface IModalFormProps {
  failedStatus: TModalStatus;
  step: TSteps;
  form: JSX.Element;
  successView: JSX.Element;
}

export const ModalForm: React.FC<IModalFormProps> = ({ failedStatus, step, form, successView }) => {
  const device = useDeviceType();

  if (failedStatus.status === EModalStatus.Failed) {
    return (
      <div className={clsx(style['container'], style[device], style['failed'])}>
        <Failed {...failedStatus.error} />
      </div>
    );
  }

  if (failedStatus.status === EModalStatus.Success) {
    return <div className={clsx(style['container'], style[device], style['success'])}>{successView}</div>;
  }

  return (
    <div className={clsx(style['container'], style[device])}>
      <Responsive desktop>
        <ModalSidebar step={step} />
      </Responsive>
      {form}
    </div>
  );
};
